import FormModal from "../../commons/form-modal";
import Input from "../../commons/input";
import { ACTION_TYPE } from "../../../constants/constant";

export const SopCategoryForm = ({
    show,
    onHide,
    title,
    actionType,
    formValue,
    onChangeName,
    isFormValid,
    onSubmitForm,
    isLoading,
}) => {
    return (
        <FormModal
            title={title || `${actionType === ACTION_TYPE.CREATE ? 'Create' : 'Edit'} SOP Category`}
            onSubmitForm={onSubmitForm}
            show={show}
            onHide={onHide}
            isDisabled={!isFormValid?.()}
            isLoading={isLoading}
        >
            <div className="flex flex-col px-6 py-8 gap-[20px]">
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70 required">Category Name</div>
                    <Input
                        name="name"
                        className="flex-1"
                        placeholder="Masukkan nama category"
                        value={formValue?.name}
                        onChange={onChangeName}
                    />
                </div>
            </div>
        </FormModal>
    );
};
